/**
 * Labstep
 */

export const BULK_OPTION = {
  label: 'Add many...',
  value: 'bulk',
};
